// partner_v1: หน้าระบบพาร์ทเนอร์ (3 tabs — ภาพรวม / รายการ / ตั้งค่าพาร์ทเนอร์)
// commission (คอมค้าง) / payout (จ่ายจริง ลง finance) / adjust (ปรับยอด)
import React, { useState, useEffect } from 'react';
import API from '../api';

const PA = '/api/finance/partners';
const PT = '/api/finance/partner-transactions';
const FB = '/api/finance/businesses';

const money = function (n) { return Number(n || 0).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
const dt = function (s) { if (!s) return '-'; try { var d = new Date(s); return d.toLocaleDateString('th-TH', { day: '2-digit', month: '2-digit' }) + ' ' + d.toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' }); } catch (e) { return s; } };

const inp = { width: '100%', padding: 9, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, marginBottom: 12, boxSizing: 'border-box' };
const lbl = { fontSize: 12, color: '#64748b', fontWeight: 600 };
const btnPrimary = { background: '#10b981', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', cursor: 'pointer', fontSize: 14, fontWeight: 600 };
const btnSec = { background: '#fff', color: '#475569', border: '1px solid #e2e8f0', borderRadius: 8, padding: '9px 18px', cursor: 'pointer', fontSize: 14, fontWeight: 600 };
const card = { background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' };

const KIND_OPTIONS = [
  { value: 'commission', label: '💰 คอมมิชชั่น (ค้างจ่าย)', effect: 1 },
  { value: 'payout', label: '💸 จ่ายจริง (ลงการเงิน)', effect: -1 },
  { value: 'adjust', label: '📝 ปรับยอด', effect: null }
];
const KIND_LABEL_MAP = { commission: 'คอมมิชชั่น', payout: 'จ่ายจริง', adjust: 'ปรับยอด' };

// ============================================
// Main Page
// ============================================
export default function BillPartners() {
  const [tab, setTab] = useState('overview');

  const tabBtn = function (key, label) {
    const active = tab === key;
    return (
      <button onClick={function () { setTab(key); }} style={{
        background: active ? '#10b981' : '#f1f5f9', color: active ? '#fff' : '#475569',
        border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontSize: 14, fontWeight: 600, marginRight: 8
      }}>{label}</button>
    );
  };

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>🤝 พาร์ทเนอร์</h2>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: '#64748b' }}>คนแนะนำลูกค้า — คอมมิชชั่นค้างจ่าย + จ่ายจริงลงการเงิน</p>
      </div>
      <div style={{ marginBottom: 16 }}>
        {tabBtn('overview', 'ภาพรวม')}
        {tabBtn('transactions', 'รายการ')}
        {tabBtn('settings', 'ตั้งค่าพาร์ทเนอร์')}
      </div>
      {tab === 'overview' && <OverviewTab />}
      {tab === 'transactions' && <TransactionsTab />}
      {tab === 'settings' && <SettingsTab />}
    </div>
  );
}

// ============================================
// Overview Tab
// ============================================
function OverviewTab() {
  const [summary, setSummary] = useState(null);
  const [partners, setPartners] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [pTxns, setPTxns] = useState({});
  const [loading, setLoading] = useState(true);

  const reload = function () {
    setLoading(true);
    Promise.all([
      API.get(PA + '/summary/balances').then(function (r) { return r.data; }).catch(function () { return null; }),
      API.get(PA).then(function (r) { return r.data; }).catch(function () { return []; })
    ]).then(function (res) {
      setSummary(res[0]); setPartners(res[1] || []); setLoading(false);
    });
  };
  useEffect(reload, []);

  const toggle = function (pid) {
    const nx = Object.assign({}, expanded); nx[pid] = !nx[pid]; setExpanded(nx);
    if (!pTxns[pid]) {
      API.get(PT + '?partner_id=' + pid + '&limit=20').then(function (r) {
        const m = Object.assign({}, pTxns); m[pid] = r.data; setPTxns(m);
      }).catch(function () {});
    }
  };

  if (loading) return <div style={{ padding: 20, color: '#94a3b8' }}>กำลังโหลด...</div>;
  const s = summary || { partners: {}, balance: {}, this_month: {} };

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12, marginBottom: 16 }}>
        <div style={card}>
          <div style={{ fontSize: 12, color: '#64748b' }}>พาร์ทเนอร์ทั้งหมด</div>
          <div style={{ fontSize: 22, fontWeight: 700 }}>{(s.partners && s.partners.active) || 0}<span style={{ fontSize: 13, color: '#94a3b8', fontWeight: 400 }}> / {(s.partners && s.partners.total) || 0}</span></div>
        </div>
        <div style={card}>
          <div style={{ fontSize: 12, color: '#64748b' }}>ค้างจ่ายรวม</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#c2410c' }}>{money((s.balance && s.balance.total_positive) || 0)}</div>
          <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>บริษัทค้างจ่าย partner</div>
        </div>
        <div style={card}>
          <div style={{ fontSize: 12, color: '#64748b' }}>ติดลบ (เบิกเกิน)</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#ef4444' }}>{(s.partners && s.partners.negative_count) || 0} <span style={{ fontSize: 13, color: '#94a3b8', fontWeight: 400 }}>ราย</span></div>
          <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>{money(Math.abs((s.balance && s.balance.total_negative) || 0))}</div>
        </div>
        <div style={card}>
          <div style={{ fontSize: 12, color: '#64748b' }}>คอมเดือนนี้</div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#10b981' }}>{money((s.this_month && s.this_month.commission && s.this_month.commission.total) || 0)}</div>
          <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>จ่ายแล้ว {money((s.this_month && s.this_month.payout && s.this_month.payout.total) || 0)}</div>
        </div>
      </div>

      <div style={Object.assign({}, card, { marginBottom: 16 })}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <span style={{ fontWeight: 700 }}>รายชื่อพาร์ทเนอร์</span>
          <span style={{ fontSize: 11, color: '#94a3b8' }}>ยอดสะสม (+ บริษัทค้างจ่าย / − partner เบิกเกิน)</span>
        </div>
        {partners.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 20, color: '#94a3b8', fontSize: 13 }}>ยังไม่มีพาร์ทเนอร์ — เพิ่มที่แท็บ "ตั้งค่าพาร์ทเนอร์"</div>
        ) : partners.map(function (p) {
          const isNeg = p.balance < 0;
          const color = isNeg ? '#ef4444' : (p.balance > 0 ? '#10b981' : '#94a3b8');
          const isOpen = !!expanded[p.id];
          return (
            <div key={p.id} style={{ borderTop: '1px solid #f1f5f9', padding: '10px 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={function () { toggle(p.id); }}>
                <div>
                  <span style={{ fontWeight: 600 }}>{p.name}</span>
                  {!p.is_active ? <span style={{ marginLeft: 6, fontSize: 10, background: '#fee2e2', color: '#b91c1c', padding: '1px 6px', borderRadius: 4 }}>ปิด</span> : null}
                  {Number(p.commission_rate) > 0 ? <span style={{ marginLeft: 6, fontSize: 10, color: '#64748b' }}>เรต {p.commission_rate}%</span> : null}
                  <div style={{ fontSize: 11, color: '#94a3b8' }}>{p.txn_count} รายการ{Number(p.opening_balance) !== 0 ? ' · ยกมา ' + money(p.opening_balance) : ''}</div>
                </div>
                <div style={{ fontSize: 16, fontWeight: 700, color: color }}>{p.balance > 0 ? '+' : ''}{money(p.balance)}</div>
              </div>
              {isOpen && (
                <div style={{ marginTop: 8, paddingLeft: 8 }}>
                  {!pTxns[p.id] ? <div style={{ fontSize: 12, color: '#94a3b8' }}>กำลังโหลด...</div> : (
                    pTxns[p.id].length === 0 ? <div style={{ fontSize: 12, color: '#94a3b8' }}>ไม่มีรายการ</div> : (
                      <table style={{ width: '100%', fontSize: 12, borderCollapse: 'collapse' }}>
                        <tbody>
                          {pTxns[p.id].map(function (t) {
                            var label = t.custom_label || KIND_LABEL_MAP[t.kind] || t.kind;
                            var sign = t.balance_effect === 1 ? '+' : '-';
                            var c = t.balance_effect === 1 ? '#10b981' : '#ef4444';
                            return (
                              <tr key={t.id}>
                                <td style={{ padding: '6px', color: '#64748b' }}>{dt(t.transaction ? t.transaction.occurred_at : t.created_at)}</td>
                                <td style={{ padding: '6px' }}>{label}{!t.transaction ? <span style={{ marginLeft: 6, fontSize: 9, background: '#fef3c7', color: '#92400e', padding: '1px 5px', borderRadius: 4 }}>ไม่ลงการเงิน</span> : null}</td>
                                <td style={{ padding: '6px' }}>{t.business ? t.business.name : '-'}</td>
                                <td style={{ padding: '6px', textAlign: 'right', fontWeight: 600, color: c }}>{sign}{money(t.amount)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    )
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ============================================
// Transactions Tab
// ============================================
function TransactionsTab() {
  const [rows, setRows] = useState([]);
  const [partners, setPartners] = useState([]);
  const [filter, setFilter] = useState({ partner_id: '', kind: '' });
  const [includeCanceled, setIncludeCanceled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);

  const reload = function () {
    setLoading(true);
    var qs = [];
    if (filter.partner_id) qs.push('partner_id=' + filter.partner_id);
    if (filter.kind) qs.push('kind=' + encodeURIComponent(filter.kind));
    if (includeCanceled) qs.push('include_canceled=true');
    qs.push('limit=100');
    API.get(PT + '?' + qs.join('&')).then(function (r) { setRows(r.data); }).catch(function () { setRows([]); }).finally(function () { setLoading(false); });
  };
  useEffect(reload, [filter, includeCanceled]);
  useEffect(function () { API.get(PA).then(function (r) { setPartners(r.data); }).catch(function () {}); }, []);

  const del = function (id) {
    if (!window.confirm('ลบรายการนี้? (ถ้าเป็นการจ่ายจริงจะลบรายการการเงินที่ผูกด้วย)')) return;
    API.delete(PT + '/' + id).then(function () { reload(); }).catch(function (e) { alert((e.response && e.response.data && e.response.data.error) || 'ลบไม่สำเร็จ'); });
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <span style={{ fontWeight: 700 }}>รายการทั้งหมด</span>
        <button onClick={function () { setShowForm(true); }} style={btnPrimary}>+ เพิ่มรายการ</button>
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap', alignItems: 'center' }}>
        <select value={filter.partner_id} onChange={function (e) { setFilter(Object.assign({}, filter, { partner_id: e.target.value })); }} style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13 }}>
          <option value="">ทุกพาร์ทเนอร์</option>
          {partners.map(function (p) { return <option key={p.id} value={p.id}>{p.name}</option>; })}
        </select>
        <select value={filter.kind} onChange={function (e) { setFilter(Object.assign({}, filter, { kind: e.target.value })); }} style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13 }}>
          <option value="">ทุกประเภท</option>
          {KIND_OPTIONS.map(function (k) { return <option key={k.value} value={k.value}>{k.label}</option>; })}
        </select>
        <label style={{ fontSize: 12, color: '#64748b', display: 'flex', alignItems: 'center', gap: 4 }}>
          <input type="checkbox" checked={includeCanceled} onChange={function (e) { setIncludeCanceled(e.target.checked); }} /> แสดงที่ยกเลิก
        </label>
      </div>
      <div style={card}>
        {loading ? <div style={{ padding: 20, color: '#94a3b8' }}>กำลังโหลด...</div> : (
          rows.length === 0 ? <div style={{ textAlign: 'center', padding: 20, color: '#94a3b8', fontSize: 13 }}>ไม่มีรายการ</div> : (
            <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ color: '#64748b', fontSize: 11, textAlign: 'left' }}>
                  <th style={{ padding: 6 }}>วันที่</th><th style={{ padding: 6 }}>พาร์ทเนอร์</th><th style={{ padding: 6 }}>ประเภท</th>
                  <th style={{ padding: 6 }}>ธุรกิจ</th><th style={{ padding: 6, textAlign: 'right' }}>ยอด</th><th style={{ padding: 6 }}></th>
                </tr>
              </thead>
              <tbody>
                {rows.map(function (t) {
                  var label = t.custom_label || KIND_LABEL_MAP[t.kind] || t.kind;
                  var sign = t.balance_effect === 1 ? '+' : '-';
                  var isCanceled = !!t.canceled_at;
                  var c = isCanceled ? '#94a3b8' : (t.balance_effect === 1 ? '#10b981' : '#ef4444');
                  return (
                    <tr key={t.id} style={{ borderTop: '1px solid #f1f5f9', textDecoration: isCanceled ? 'line-through' : 'none', opacity: isCanceled ? 0.6 : 1 }}>
                      <td style={{ padding: 6, color: '#64748b' }}>{dt(t.transaction ? t.transaction.occurred_at : t.created_at)}</td>
                      <td style={{ padding: 6 }}>{t.partner ? t.partner.name : '-'}</td>
                      <td style={{ padding: 6 }}>
                        {label}
                        {!t.transaction ? <span style={{ marginLeft: 6, fontSize: 10, background: '#fef3c7', color: '#92400e', padding: '1px 6px', borderRadius: 4 }}>ไม่ลงการเงิน</span> : null}
                      </td>
                      <td style={{ padding: 6 }}>{t.business ? t.business.name : '-'}</td>
                      <td style={{ padding: 6, textAlign: 'right', fontWeight: 600, color: c }}>{sign}{money(t.amount)}</td>
                      <td style={{ padding: 6, textAlign: 'right' }}>
                        {!isCanceled ? <button onClick={function () { del(t.id); }} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 12 }}>ลบ</button> : null}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )
        )}
      </div>
      {showForm && <PartnerTxnFormModal partners={partners} onClose={function () { setShowForm(false); }} onSaved={function () { setShowForm(false); reload(); }} />}
    </div>
  );
}

// ============================================
// Transaction Form Modal
// ============================================
function PartnerTxnFormModal(props) {
  const [form, setForm] = useState({ kind: 'commission', partner_id: '', amount: '', reference_amount: '', business_id: '', account_id: '', note: '', custom_label: '', balance_effect: 1 });
  const [businesses, setBusinesses] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(function () { API.get(FB).then(function (r) { setBusinesses(r.data); }).catch(function () {}); }, []);
  useEffect(function () {
    if (form.business_id) {
      API.get(FB + '/' + form.business_id + '/accounts').then(function (r) { setAccounts(r.data); }).catch(function () { setAccounts([]); });
    } else setAccounts([]);
  }, [form.business_id]);

  const selectedPartner = props.partners.find(function (p) { return p.id === form.partner_id; });
  const partnerRate = selectedPartner ? Number(selectedPartner.commission_rate) || 0 : 0;
  // คำนวณคอมจาก % (โชว์ให้ดู ตอน commission + มี ref + มี rate + ไม่กรอก amount)
  const calcCommission = (form.kind === 'commission' && partnerRate > 0 && form.reference_amount && (!form.amount)) ? Math.round(Number(form.reference_amount) * partnerRate / 100 * 100) / 100 : null;

  const set = function (k, v) { setForm(Object.assign({}, form, (function () { var o = {}; o[k] = v; return o; })())); };

  const submit = function () {
    setErr('');
    if (!form.partner_id) { setErr('กรุณาเลือกพาร์ทเนอร์'); return; }
    var amt = Number(form.amount);
    // commission: ถ้าไม่กรอก amount แต่มี ref+rate → ใช้ calcCommission
    if (form.kind === 'commission' && (!form.amount) && calcCommission) amt = calcCommission;
    if (!isFinite(amt) || amt <= 0) { setErr('กรุณากรอกยอด (หรือยอดอ้างอิง + พาร์ทเนอร์มีเรตคอม)'); return; }
    if (form.kind === 'payout' && !form.business_id) { setErr('การจ่ายจริงต้องเลือกธุรกิจ'); return; }
    if (form.kind === 'adjust' && (!form.custom_label || !form.custom_label.trim())) { setErr('กรุณาระบุชื่อรายการปรับยอด'); return; }

    var payload = { partner_id: form.partner_id, kind: form.kind, note: form.note || null };
    if (form.kind === 'commission') {
      if (form.amount) payload.amount = amt; else payload.reference_amount = Number(form.reference_amount);
      if (form.business_id) payload.business_id = form.business_id;
    } else if (form.kind === 'payout') {
      payload.amount = amt; payload.business_id = form.business_id;
      if (form.account_id) payload.account_id = form.account_id;
    } else if (form.kind === 'adjust') {
      payload.amount = amt; payload.balance_effect = Number(form.balance_effect); payload.custom_label = form.custom_label;
      if (form.business_id) payload.business_id = form.business_id;
    }
    setSaving(true);
    API.post(PT, payload).then(function () { props.onSaved(); }).catch(function (e) {
      setErr((e.response && e.response.data && e.response.data.error) || 'บันทึกไม่สำเร็จ'); setSaving(false);
    });
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 24, maxWidth: 440, width: '100%', maxHeight: '90vh', overflowY: 'auto' }}>
        <h3 style={{ marginTop: 0 }}>เพิ่มรายการพาร์ทเนอร์</h3>
        {err ? <div style={{ background: '#fee2e2', color: '#b91c1c', padding: 10, borderRadius: 8, fontSize: 13, marginBottom: 12 }}>{err}</div> : null}

        <label style={lbl}>ประเภท</label>
        <select value={form.kind} onChange={function (e) { set('kind', e.target.value); }} style={inp}>
          {KIND_OPTIONS.map(function (k) { return <option key={k.value} value={k.value}>{k.label}</option>; })}
        </select>

        <label style={lbl}>พาร์ทเนอร์</label>
        <select value={form.partner_id} onChange={function (e) { set('partner_id', e.target.value); }} style={inp}>
          <option value="">— เลือก —</option>
          {props.partners.filter(function (p) { return p.is_active; }).map(function (p) { return <option key={p.id} value={p.id}>{p.name}{Number(p.commission_rate) > 0 ? ' (' + p.commission_rate + '%)' : ''}</option>; })}
        </select>

        {form.kind === 'commission' && partnerRate > 0 ? (
          <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, padding: 10, marginBottom: 12, fontSize: 12, color: '#15803d' }}>
            พาร์ทเนอร์นี้มีเรต {partnerRate}% — กรอก "ยอดอ้างอิง" ระบบคิดคอมให้ หรือกรอก "ยอดคอม" เองก็ได้
          </div>
        ) : null}

        {form.kind === 'commission' && partnerRate > 0 ? (
          <div>
            <label style={lbl}>ยอดอ้างอิง (ยอดที่ลูกค้าจ่าย) — คิด {partnerRate}%</label>
            <input type="number" value={form.reference_amount} onChange={function (e) { set('reference_amount', e.target.value); }} style={inp} placeholder="เช่น 10000" />
            {calcCommission ? <div style={{ fontSize: 12, color: '#10b981', marginTop: -8, marginBottom: 10 }}>→ คอม {money(calcCommission)} บาท</div> : null}
          </div>
        ) : null}

        <label style={lbl}>{form.kind === 'commission' && partnerRate > 0 ? 'หรือ ยอดคอม (กรอกเอง)' : 'จำนวนเงิน'}</label>
        <input type="number" value={form.amount} onChange={function (e) { set('amount', e.target.value); }} style={inp} placeholder="0.00" />

        {form.kind === 'adjust' ? (
          <div>
            <label style={lbl}>ทิศทาง</label>
            <select value={form.balance_effect} onChange={function (e) { set('balance_effect', e.target.value); }} style={inp}>
              <option value={1}>+ เพิ่มยอด (บริษัทค้างจ่ายเพิ่ม)</option>
              <option value={-1}>− ลดยอด (partner เบิก/หัก)</option>
            </select>
            <label style={lbl}>ชื่อรายการ</label>
            <input value={form.custom_label} onChange={function (e) { set('custom_label', e.target.value); }} style={inp} placeholder="เช่น ปรับยอดยกมา, หักหนี้เก่า" />
          </div>
        ) : null}

        {(form.kind === 'payout' || form.kind === 'commission' || form.kind === 'adjust') ? (
          <div>
            <label style={lbl}>ธุรกิจ {form.kind === 'payout' ? '(จำเป็น — ลงรายจ่าย)' : '(ไม่บังคับ)'}</label>
            <select value={form.business_id} onChange={function (e) { set('business_id', e.target.value); }} style={inp}>
              <option value="">— {form.kind === 'payout' ? 'เลือกธุรกิจ' : 'ไม่ระบุ'} —</option>
              {businesses.map(function (b) { return <option key={b.id} value={b.id}>{b.name}</option>; })}
            </select>
          </div>
        ) : null}

        {form.kind === 'payout' && form.business_id ? (
          <div>
            <label style={lbl}>บัญชีที่จ่าย (ไม่บังคับ)</label>
            <select value={form.account_id} onChange={function (e) { set('account_id', e.target.value); }} style={inp}>
              <option value="">— ไม่ระบุบัญชี —</option>
              {accounts.map(function (a) { return <option key={a.id} value={a.id}>{a.account_name}</option>; })}
            </select>
          </div>
        ) : null}

        <label style={lbl}>หมายเหตุ (ไม่บังคับ)</label>
        <input value={form.note} onChange={function (e) { set('note', e.target.value); }} style={inp} placeholder="" />

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
          <button onClick={props.onClose} style={btnSec} disabled={saving}>ยกเลิก</button>
          <button onClick={submit} style={btnPrimary} disabled={saving}>{saving ? 'กำลังบันทึก...' : 'บันทึก'}</button>
        </div>
      </div>
    </div>
  );
}

// ============================================
// Settings Tab
// ============================================
function SettingsTab() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);

  const reload = function () {
    setLoading(true);
    API.get(PA + '?active=').then(function (r) { setPartners(r.data); }).catch(function () { setPartners([]); }).finally(function () { setLoading(false); });
  };
  useEffect(reload, []);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <span style={{ fontWeight: 700 }}>พาร์ทเนอร์</span>
        <button onClick={function () { setEditing(null); setShowForm(true); }} style={btnPrimary}>+ เพิ่มพาร์ทเนอร์</button>
      </div>
      <div style={card}>
        {loading ? <div style={{ padding: 20, color: '#94a3b8' }}>กำลังโหลด...</div> : (
          partners.length === 0 ? <div style={{ textAlign: 'center', padding: 20, color: '#94a3b8', fontSize: 13 }}>ยังไม่มีพาร์ทเนอร์</div> : (
            <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ color: '#64748b', fontSize: 11, textAlign: 'left' }}>
                  <th style={{ padding: 6 }}>ชื่อ</th><th style={{ padding: 6, textAlign: 'right' }}>เรตคอม</th><th style={{ padding: 6, textAlign: 'right' }}>ยอดยกมา</th><th style={{ padding: 6 }}>สถานะ</th><th style={{ padding: 6 }}></th>
                </tr>
              </thead>
              <tbody>
                {partners.map(function (p) {
                  return (
                    <tr key={p.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                      <td style={{ padding: 6, fontWeight: 600 }}>{p.name}{p.note ? <div style={{ fontSize: 11, color: '#94a3b8', fontWeight: 400 }}>{p.note}</div> : null}</td>
                      <td style={{ padding: 6, textAlign: 'right' }}>{Number(p.commission_rate) > 0 ? p.commission_rate + '%' : '-'}</td>
                      <td style={{ padding: 6, textAlign: 'right' }}>{Number(p.opening_balance) !== 0 ? money(p.opening_balance) : '-'}</td>
                      <td style={{ padding: 6 }}>{p.is_active ? <span style={{ fontSize: 11, color: '#15803d' }}>● ใช้งาน</span> : <span style={{ fontSize: 11, color: '#94a3b8' }}>○ ปิด</span>}</td>
                      <td style={{ padding: 6, textAlign: 'right' }}>
                        <button onClick={function () { setEditing(p); setShowForm(true); }} style={{ background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', fontSize: 12 }}>แก้ไข</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )
        )}
      </div>
      {showForm && <PartnerFormModal editing={editing} onClose={function () { setShowForm(false); }} onSaved={function () { setShowForm(false); reload(); }} />}
    </div>
  );
}

// ============================================
// Partner Form Modal (create/edit)
// ============================================
function PartnerFormModal(props) {
  const ed = props.editing;
  const [form, setForm] = useState({
    name: ed ? ed.name : '', note: ed ? (ed.note || '') : '',
    opening_balance: ed ? String(ed.opening_balance || 0) : '0',
    commission_rate: ed ? String(ed.commission_rate || 0) : '0',
    is_active: ed ? ed.is_active : true
  });
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);
  const set = function (k, v) { setForm(Object.assign({}, form, (function () { var o = {}; o[k] = v; return o; })())); };

  const submit = function () {
    setErr('');
    if (!form.name.trim()) { setErr('กรุณากรอกชื่อ'); return; }
    var payload = {
      name: form.name.trim(), note: form.note || null,
      opening_balance: Number(form.opening_balance) || 0,
      commission_rate: Number(form.commission_rate) || 0,
      is_active: form.is_active
    };
    setSaving(true);
    var req = ed ? API.put(PA + '/' + ed.id, payload) : API.post(PA, payload);
    req.then(function () { props.onSaved(); }).catch(function (e) {
      setErr((e.response && e.response.data && e.response.data.error) || 'บันทึกไม่สำเร็จ'); setSaving(false);
    });
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 24, maxWidth: 420, width: '100%' }}>
        <h3 style={{ marginTop: 0 }}>{ed ? 'แก้ไขพาร์ทเนอร์' : 'เพิ่มพาร์ทเนอร์'}</h3>
        {err ? <div style={{ background: '#fee2e2', color: '#b91c1c', padding: 10, borderRadius: 8, fontSize: 13, marginBottom: 12 }}>{err}</div> : null}
        <label style={lbl}>ชื่อ</label>
        <input value={form.name} onChange={function (e) { set('name', e.target.value); }} style={inp} />
        <label style={lbl}>เรตคอมมิชชั่น (%) — ไม่บังคับ</label>
        <input type="number" value={form.commission_rate} onChange={function (e) { set('commission_rate', e.target.value); }} style={inp} placeholder="0" />
        <label style={lbl}>ยอดยกมา (เครดิตเก่า — บวก = บริษัทค้างจ่าย, ลบ = partner เบิกเกิน)</label>
        <input type="number" value={form.opening_balance} onChange={function (e) { set('opening_balance', e.target.value); }} style={inp} placeholder="0" />
        <label style={lbl}>หมายเหตุ</label>
        <input value={form.note} onChange={function (e) { set('note', e.target.value); }} style={inp} />
        {ed ? (
          <label style={{ fontSize: 13, color: '#475569', display: 'flex', alignItems: 'center', gap: 6, marginBottom: 12 }}>
            <input type="checkbox" checked={form.is_active} onChange={function (e) { set('is_active', e.target.checked); }} /> ใช้งานอยู่
          </label>
        ) : null}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={props.onClose} style={btnSec} disabled={saving}>ยกเลิก</button>
          <button onClick={submit} style={btnPrimary} disabled={saving}>{saving ? 'กำลังบันทึก...' : 'บันทึก'}</button>
        </div>
      </div>
    </div>
  );
}
